import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedsysService {

  // datos reales
  private MONEDA = '978';
  private URL_NOTIFICACION_ONLINE = 'https://us-central1-playbotscms.cloudfunctions.net/updateStateReceiptsPOST';
  private TERMINAL_ASIGNADO_POR_BANCO = '1';
  private TIPO_TRANSACCION = '0';
  private URL_ERROR = 'https://playbots-areadeltutorlab.web.app/pago/{idtutor}';
  /* private URLREDSYS = 'https://sis.redsys.es/sis/realizarPago';
  private URL_SUCCESS = 'https://us-central1-playbotscms.cloudfunctions.net/updateStateReceipts/{idReceipts}';  
  private CODIGO_FUG_COMERCIO = '34820753';  
  private SECRET_COD = 'bjFpfWkzoi4bm97VbHA/Ge1M+iUZQ8o5'; */

  /* datos pruebas */
  private URLREDSYS = environment.redsys.URLREDSYS;
  private URL_SUCCESS = environment.redsys.URL_SUCCESS;
  private CODIGO_FUG_COMERCIO = environment.redsys.CODIGO_FUG_COMERCIO;
  private SECRET_COD = environment.redsys.SECRET_COD;

  constructor(
    public cloudFunctions: AngularFireFunctions
  ) { }

  async generarEnvioRedsys(infoEmail: any) {
    let urlOK = '';
    let urlKO = '';
    if (infoEmail[`idTutor`] !== null && infoEmail[`idTutor`] !== undefined) {
      urlOK = this.URL_SUCCESS.replace('{idtutor}', infoEmail[`idTutor`]);
      urlKO = this.URL_ERROR.replace('{idtutor}', infoEmail[`idTutor`]);
    }
    // const amount = infoEmail[`discount`] ? infoEmail[`total`] - 5 : infoEmail[`total`];
    const amount = infoEmail[`total`];
    let amountDecimal = amount.toFixed(2);
    amountDecimal = amountDecimal.replace('.', '');
    const numeroOrder = infoEmail[`numberOrder`].replace('/', '');
    const tutorName = infoEmail[`namefullTutor`] ? this.replaceTildes(infoEmail[`namefullTutor`]) :
      this.replaceTildes(infoEmail[`nameTutor`]);
    const emailTutor = infoEmail[`emailTutor`];
    const phoneTutor = infoEmail[`phoneTutor`];
    const nameStundent = this.replaceTildes(infoEmail[`nameStudent`]);
    const nametutor = this.replaceTildes(infoEmail[`nameTutor`]);
    const xmlData = {
      nombreComprador: tutorName,
      textoLibre1: `Hola ${nametutor},
      Te informamos que ya esta disponible el recibo mensual de  ${nameStundent} para su abono.
      Recuerda que para beneficiarte de la promocion Tarjeta 5 has de abonar el recibo entre los días 1 y 5 de cada mes.
      Un saludo y gracias por tu colaboracion.`
    };
    const smsText = `Ya está disponible el recibo Playbots de ${nameStundent}. Puede pagar en el siguiente enlace @URL@`;
    return await this.cloudFunctions.httpsCallable('createPaymentAreaTutor')({
      AMOUNT: amountDecimal,  // importe
      CURRENCY: this.MONEDA,  // moneda
      MERCHANTCODE: this.CODIGO_FUG_COMERCIO, // codigo FUC asignado al comercio
      MERCHANTURL: this.URL_NOTIFICACION_ONLINE,  //  URL noticiaciones online
      ORDER: numeroOrder, // numero de orden  4 primeros numeros   el resto ascii
      TERMINAL: this.TERMINAL_ASIGNADO_POR_BANCO, // numero de terminal que asigna el banco
      TRANSACTIONTYPE: this.TIPO_TRANSACCION, // tipo de transaccion
      URLKO: urlOK,
      URLOK: urlOK,
      secret: this.SECRET_COD,
      EXPIRYDATE: infoEmail[`expiryDate`],
      TUTOR: `${tutorName.toUpperCase() ? tutorName.toUpperCase() : ''}`,
      PRODUCTDESCRIPTION: `RECIBO PLAYBOTS ${nameStundent.toUpperCase() ? nameStundent.toUpperCase() : ''}`,
      MAIL: emailTutor,
      MOBILE: `${phoneTutor}`,
      XMLDATA: xmlData,
      SMS_TEXT: smsText
    }).toPromise().then((responseSus) => {
      console.log('el resultado de la function es ', responseSus);
      if (responseSus[`success`]) {
        const dataRedsys = {
          Ds_SignatureVersion: environment.redsys.dsSignatureVersion,
          Ds_MerchantParameters: responseSus[`Ds_MerchantParameters`],
          Ds_Signature: responseSus[`Ds_Signature`]
        };
        return dataRedsys;
      } else {
        return responseSus;
      }

    });
  }

  async generatePayGold(dataRedsys: any) {
    return await this.cloudFunctions.httpsCallable('redsysRest')({
      dataRedsysRest: dataRedsys,
      urlRedsys: this.URLREDSYS
    }
    ).toPromise().then((responseSus) => {
      console.log('el resultado de la function es ', responseSus);
      if (responseSus[`success`]) {
        return responseSus;
      } else {
        return responseSus;
      }

    });
  }

  decodeRedsysResponse(dataRedsys: any) {
    return this.cloudFunctions.httpsCallable('decodeRedsysAreaTutor')(dataRedsys)
      .toPromise().then((responseSus) => {
        console.log('el resultado de la function es ', responseSus);
        if (responseSus[`success`]) {
          return responseSus[`success`];
        } else {
          return responseSus[`invalid`];
        }

      });
  }

  replaceTildes(text: string) {
    const tittles = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
    const original = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc';
    for (let i = 0; i < tittles.length; i++) {
      text = text.replace(tittles.charAt(i), original.charAt(i)).toLowerCase();
    }
    return text;
  }
}
